import style from './CardThumbnail.css';
import { CardType, getCardAssetURL } from '../../../clients/card.backgrounds';

const CardThumbnailSize = {
  SMALL: 'small',
  LARGE: 'large',
};
export default function CardThumbnail({
  className = '',
  organization,
  size = CardThumbnailSize.LARGE,
  ...props
}) {
  return (
    <div
      className={`${className} ${style['card-thumbnail']} ${style[size]}`}
      {...props}
    >
      <img
        className={style['card-bg']}
        src={getCardAssetURL(organization, CardType.THUMBNAIL)}
      />
      <img
        className={style['card-client']}
        src={getCardAssetURL(organization, CardType.LOGO)}
      />
    </div>
  );
}

CardThumbnail.Size = CardThumbnailSize;
